module.exports = __webpack_public_path__ + "img/meet-your-side-kicks-bg.7d6029ce.png";